export const RESET = 'LABEL_UPDATE_RESET'
export const SET_ERROR = 'LABEL_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'LABEL_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'LABEL_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'LABEL_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'LABEL_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'LABEL_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'LABEL_UPDATE_FILES'



// WEBPACK FOOTER //
// ./src/store/modules/label/update/mutation_types.js